import React, {useEffect} from "react";
                                             
import {Swiper} from "swiper/react";
import "./ProductListPage.scss";
                                            
import {withTranslation} from "react-i18next";
import ProductDoubleSwiperSlider from "./ProductDoubleSwiperSlider";
import {useParams} from "react-router";
import Pagination from "./Pagination";

                               
                     
                    
              
                           
                      
                          
                         
                          
                    
                    
                     
  

const SearchPage = (props                 ) => {
	const {products, searchPhrase, setSearch} = props;
	const {fuzzy} = useParams();

	useEffect(() => {
		if (searchPhrase === null || fuzzy !== searchPhrase) {
			setSearch(fuzzy);
		}
	}, [searchPhrase, setSearch, fuzzy]);

	const handleHistoryBack = e => {
		e.preventDefault();
		props.goHome();
	};

	return	<div className="main" data-testid={"searchPage"}>
		<div className="control">
			<span><button className="toggle-detail" onClick={e => handleHistoryBack(e)}>{props.t("navigation.back")}</button></span>
			<span></span>
		</div>
		<div className="head">
			<span>
				{props.selectedCategory
					? props.t("navigation.searching.found.withCategory", {fuzzy: searchPhrase, category: props.selectedCategory})
					: props.t("navigation.searching.found.withOutCategory", {fuzzy: searchPhrase})
				}
			</span>
			<Pagination
				currentPageIndex={props.currentPageIndex}
				totalPages={props.totalPages}
				totalItems={props.totalItems}
				itemsPerPage={props.itemsPerPage}
				setPage={props.setPage}
				t={props.t}
			/>
		</div>
		<div id={"category"} className={"swiper"}>
			<Swiper
				className={"swiper-container swiper-list"}
				slidesPerView={1}
				spaceBetween={5}
				autoHeight={true}
				autoPlay={{delay: 9000}}
				loop={products.length > 8}
				grabCursor={true}
				loopAdditionalSlides={7}
				navigation={{
					addIcons: false,
					nextEl: ".slider-button-next-1",
					prevEl: ".slider-button-prev-1",
				}}
				onResize={swiper => {
					document.querySelectorAll(".swiper-list > .swiper-wrapper").forEach(it => {
						it.style.height = "auto";
					});
					swiper.updateAutoHeight();
				}}
			>
				<ProductDoubleSwiperSlider products={products}/>
			</Swiper>
			<div className="swiper-button-next swiper-button-next-tip slider-button-next-1" tabIndex={"0"} role={"button"}
				 aria-label={props.t("main.nextSlide")}/>
			<div className="swiper-button-prev swiper-button-prev-tip slider-button-prev-1" tabIndex={"0"} role={"button"}
				 aria-label={props.t("main.prevSlide")}/>
		</div>
	</div>;
};

export default withTranslation()(SearchPage);
